import { Link } from "react-router-dom";
import { allCategories } from "@/lib/articles";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 lg:pr-10">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-lg font-bold">
                鲁
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">鲁啊鲁</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 max-w-md">
              鲁啊鲁是一个多元内容展示与资讯平台，覆盖文化、娱乐、生活等多个领域，致力于为用户提供丰富、真实、易读的内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-900 text-background-100 cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-900 text-background-100 cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-900 text-background-100 cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#footer-nav" className="hover:text-primary-300 transition-colors">
                内容分类
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {allCategories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-background-200/80 hover:text-primary-300 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/"
                  className="text-background-200/80 hover:text-primary-300 transition-colors"
                >
                  最新资讯
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#footer-about" className="hover:text-primary-300 transition-colors">
                关于与帮助
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-background-200/80 hover:text-primary-300 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-background-200/80 hover:text-primary-300 transition-colors"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-background-200/80 hover:text-primary-300 transition-colors"
                >
                  网站地图
                </Link>
              </li>
              <li>
                <Link
                  to="/search?q=专题"
                  className="text-background-200/80 hover:text-primary-300 transition-colors"
                >
                  精选专题
                </Link>
              </li>
            </ul>
            <p className="mt-5 text-sm text-background-200/80">邮箱：hello@lualu.com</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 鲁啊鲁 · 多元内容展示与资讯平台 · 保留所有权利</p>
          <p>本站内容为演示数据，仅用于展示平台功能。</p>
        </div>
      </div>
    </footer>
  );
}